import React, { useState } from "react"
import RemoveFromCartButton from "./RemoveFromCartButton"
import { useDispatch, useSelector } from "react-redux"
import {
  removeFromCart,
  updateCartQuantity,
  updateGuestCartQuantity,
  removeFromGuestCart,
} from "../store"
import "./styles/CartItem.css"

const CartItem = ({ product }) => {
  const auth = useSelector((state) => state.auth)
  const [quantity, setQuantity] = useState(product.quantity)
  const dispatch = useDispatch()

  const handleQuantityIncrement = () => {
    if (auth.id) {
      const updatedCart = {
        product,
        quantity: parseInt(quantity) + 1,
      }
      dispatch(updateCartQuantity(updatedCart))
      setQuantity(quantity + 1)
    } else {
      dispatch(
        updateGuestCartQuantity({
          productId: product.product.id,
          quantity: quantity + 1,
        })
      )
      setQuantity(quantity + 1)
    }
  }

  const handleQuantityChange = (e) => {
    const newQuantity = parseInt(e.target.value, 10)
    if (isNaN(newQuantity) || newQuantity < 0) {
      setQuantity(0)
      return
    }

    setQuantity(newQuantity)
    if (auth.id) {
      dispatch(updateCartQuantity({ product, quantity: newQuantity }))
    } else {
      dispatch(
        updateGuestCartQuantity({
          productId: product.product.id,
          quantity: newQuantity,
        })
      )
    }
  }

  const handleQuantityDecrement = async () => {
    if (auth.id) {
      const updatedCart = {
        product,
        quantity: parseInt(quantity) - 1,
      }
      dispatch(updateCartQuantity(updatedCart))
      setQuantity(quantity - 1)
      if (quantity - 1 === 0) {
        dispatch(removeFromCart({ product: product }))
      }
    } else {
      dispatch(
        updateGuestCartQuantity({
          productId: product.product.id,
          quantity: quantity - 1,
        })
      )
      setQuantity(quantity - 1)
      if (quantity - 1 === 0) {
        dispatch(removeFromGuestCart({ product: { product } }))
      }
    }
  }
  return (
    <div className="card">
      <figure className="cart-item-image">
        <img src={product.product.imageURL} alt={product.product.name} />
      </figure>
      <div className="card-body">
        <h1 className="card-product-name">{product.product.name}</h1>
        <div className="badge">
          <span className="text-lg">$</span>
          <span className="card-product-price">{product.product.price}</span>
        </div>
        <div className="card-quantity-actions">
          <button
            className="card-increment-btn"
            onClick={handleQuantityIncrement}
          >
            +
          </button>
          <input
            type="number"
            className="card-selected-quantity"
            value={quantity}
            onChange={handleQuantityChange}
          />
          <button
            className="card-decrement-btn"
            onClick={handleQuantityDecrement}
          >
            -
          </button>
        </div>
        <div className="card-actions">
          <RemoveFromCartButton
            className="remove-cart-btn"
            product={product}
            quantity={product.quantity}
          />
        </div>
      </div>
    </div>
  )
}

export default CartItem
